let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "Dylan Cuskelly",
    "role": "Physicist and Engineer",
    "linkedinId":"Your LinkedIn Id",
    "skypeid": "Your skypeid",
    "roleDescription": "I am a project orientated physicist with a passion for the appliction of cutting edge technology. When I'm not developing Martian Concrete, I'm making hyperloop pod simulations or learning how to apply Machine Leanring through fastai",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/dylan-c-186ba710b/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/dylancusk",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"https://twitter.com/dylan_cusk",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme":"I am currently a second year student at Trinity College Dublin and pursuing my B.A. in Physics from here. I am an experimentalist, currently diving into Machine Learning. I am forever curious.",
    "address":"Ireland",
    "website":"",
    "education":[
      {
        "UniversityName":"Trinity College Dublin",
        "specialization":"Physics",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2022",
        "Achievements":"1st in all modules to date, Undertook Scholarship Exams"
      },
      {
        "UniversityName":"Tullamore College",
        "specialization":"",
        "MonthOfPassing":"June",
        "YearOfPassing":"2018",
        "Achievements":"625 points in Leaving Certificate Exams, Naughton Scholarship"
      }
    ],
    "work":[
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      },
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      }
    ],
    "skillsDescription":"Your skills here",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      }
    ],
    "portfolio":[
      {
        "name":"project1",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      },
      {
        "name":"project2",
        "description":"mobileapp",
        "imgurl":"images/portfolio/project.jpg"
      },
      {
        "name":"project3",
        "description":"mobileapp",  
        "imgurl":"images/portfolio/project2.png"
      },
      {
        "name":"project4",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      }
    ],
    "testimonials":[
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      },
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      }
    ]
  }
  
  export default resumeData
